import { render, staticRenderFns } from "./OfficeScreen.vue?vue&type=template&id=c18cd80c&scoped=true&"
import script from "./OfficeScreen.vue?vue&type=script&lang=js&"
export * from "./OfficeScreen.vue?vue&type=script&lang=js&"
import style0 from "./OfficeScreen.vue?vue&type=style&index=0&id=c18cd80c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18cd80c",
  null
  
)

export default component.exports